import React from "react";
import { AppButton } from "components";

type Props = {
  handleShare: (option: "twitter" | "facebook" | "linkedin") => void;
  width?: string;
};

export const ShareBtn: React.FC<Props> = ({ handleShare }) => {
  return (
    <AppButton onClick={() => handleShare("linkedin")}>Share</AppButton>
    //<Popover content={<ShareOptions handleShare={handleShare} />}>
    //  <AppButton>Share</AppButton>
    //</Popover>
  );
};

//const Button = styled.button`
//  width: 50px;
//          height: 50px;
//          border-radius: 57px;
//          border: 1px solid #2e2d33;
//
//          background: #17161c;
//          display: flex;
//          justify-content: center;
//          align-items: center;
//          cursor: pointer;
//          overflow: hidden;
//`;
//
//type ShareBtnProps = {
//  handleShare: (option: 'twitter' | 'facebook' | 'linkedin') => void;
//};
//function ShareOptions(props: ShareBtnProps) {
//  return (
//    <div className={css`
//      display: flex;
//      flex-direction: row;
//      justify-content: space-between;
//      align-items: center;
//      padding: 10px;
//      top: -100px;
//    `}>
//      <Button onClick={() => props.handleShare('linkedin')}>
//        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M26.5 4.5h-21a1 1 0 0 0-1 1v21a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-21a1 1 0 0 0-1-1M15 14v8m-4-8v8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 17.5a3.5 3.5 0 1 1 7 0V22" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" fill="#fff"/></svg>
//      </Button>
//
//      <Button onClick={() => props.handleShare('twitter')}>
//        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M16 11c0-2.75 2.313-5.038 5.063-5a5 5 0 0 1 4.525 3H30l-4.038 4.037A15.99 15.99 0 0 1 10 28c-4 0-5-1.5-5-1.5S9 25 11 22c0 0-8-4-6-15 0 0 5 5 11 6z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
//      </Button>
//
//      <Button onClick={() => props.handleShare('facebook')}>
//        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 11h-2a2.99 2.99 0 0 0-3 3v14m-4-10h8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
//      </Button>
//    </div>
//  )
//}

